<template src="./video.html"></template>

<script>
import TopService from 'Services/TopService';

export default {
  data() {
    return {
      videoIdJP: null,
      videoIdVN: null,
      i18n: 2,
      dataJP: null,
      startJP: null,
      dataVN: null,
      startVN: null,
    };
  },

  created() {
    this.list();
  },

  methods: {
    list() {
      if (localStorage.getItem('lang') === 'ja') {
        this.i18n = 1;
      }
      const paramsJP = {
        national: 1,
        i18n: this.i18n,
      };
      const paramsVN = {
        national: 2,
        i18n: this.i18n,
      };

      TopService.listVideo(paramsJP)
        .then((response) => {
          this.dataJP = response.data.link_video;
          this.startJP = this.dataJP.search('=');
          this.videoIdJP = this.dataJP.substr(this.startJP + 1);
        })
        .catch(() => {
        });
      TopService.listVideo(paramsVN)
        .then((response) => {
          this.dataVN = response.data.link_video;
          this.startVN = this.dataVN.search('=');
          this.videoIdVN = this.dataVN.substr(this.startVN + 1);
        })
        .catch(() => {
        });
    },
    ready(event) {
      this.player = event.target;
    },
    stop() {
      this.player.stopVideo();
    },
    pause() {
      this.player.pauseVideo();
    },
  },
};
</script>
<style scoped>
pre {
     text-align: justify;
     /* white-space: pre-line; */
};
</style>
